import { AppThunk } from "../store";
import { setData, setError, setLoading, setPreviousRecipients } from "../slices/sharedDefectsSlice";
import { getPreviousRecipients, getSharedDefects } from "../../services/SharedDefectsService";
import { appendCustomFields } from "../../utils/SharedDefectsTableDataHelper";
import { sortDefectsByPriorityCostAndDate } from "../../utils/DefectsTableDataHelper";
import { selectUserId } from "../selectors/userSelectors";
import { fetchDefectsEvidence } from "./defectThunks";
import { selectSharedDefectsData } from "../selectors/sharedDefectsSelectors";
import { mapRectifiedEvidence } from "../../utils/DefectRectificationHelpers";
import { SharedDefectItem } from "../../types/SharedDefectItem";
import { setEvidenceLoading } from "../slices/rectificationSlice";
import { getShipDetails } from "../../services/ShipService";

export const fetchSharedDefects = (): AppThunk => async (dispatch, getState) => {
    const userId = selectUserId(getState());

    if (userId) {
        dispatch(setLoading(true));
        dispatch(setError(false));

        try {
            const response = await getSharedDefects(userId);

            const imos = response.map((item: { imo: string }) => item.imo);
            const shipDetails = await getShipDetails(imos);
    
            if (response) {
                const data = appendCustomFields(response, shipDetails);
                const sortedData = sortDefectsByPriorityCostAndDate(data);

                dispatch(setData(sortedData));
                dispatch(fetchDefectsEvidence());
            } else {
                throw Error('no data');
            }
        } catch (e) {
            console.error(e);
            dispatch(setError(true));
        } finally {
            dispatch(setLoading(false));
        }
    }
};

export const fetchPreviousRecipients = (): AppThunk => async (dispatch) => {
    try {
        const response = await getPreviousRecipients();

        if (response.data) {
            dispatch(setPreviousRecipients(response.data));
        } else {
            throw Error('no data');
        }
    } catch (e) {
        console.error(e);
        dispatch(setError(true));
    } finally {
        dispatch(setLoading(false));
    }
};

export const fetchSharedDefectsEvidence =
    (): AppThunk => async (dispatch, getState) => {
        const sharedDefects = selectSharedDefectsData(getState());

        // mapRectifiedEvidence returns the same defects in the same order, so it
        // can be used directly. Re-joining it onto the original list by defectId
        // collapsed defects that share an id across inspections onto one vessel.
        const sharedDefectsWithEvidence = (await mapRectifiedEvidence(
            sharedDefects
        )) as SharedDefectItem[];

        dispatch(setData(sharedDefectsWithEvidence));
        dispatch(setEvidenceLoading(false));
    };
